<p>request-password-reset works!</p>
